import { render, staticRenderFns } from "./myLink.vue?vue&type=template&id=6f51f094&functional=true&"
import script from "./myLink.vue?vue&type=script&lang=js&"
export * from "./myLink.vue?vue&type=script&lang=js&"
import style0 from "./myLink.vue?vue&type=style&index=0&id=6f51f094&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports